import {useDelayedValue} from './useDelayedValue'

export const useDelayedRender = (delay: number) => {
  const shouldRender = useDelayedValue(delay, true, false)

  return <T>(fn: () => T): T | null => shouldRender && fn()
}
